// Shared BI event name enum — safe to import from both server and client code.
export enum BiEvent {
  Visit = "visits",
  SearchItems = "ecommerce-search",
  SearchOutbound = "ecommerce-search-outbounds",
  BannerOutbound = "banners-outbounds",
}

export enum PageType {
  Homepage = "homepage",
  Search = "search",
  Best = "best",
  Page = "page",
}

export enum Sort {
  Curated = "curated",
}
